export default "__VITE_ASSET__BAlZSGst__"